import { DSIndigo, MavenPro } from '@olive/fonts'

export default [DSIndigo, MavenPro]
